import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// interface WatchHistoryItem {
//   videoId: string;
// }

// interface WatchHistoryState {
//   watchHistoryVideos: WatchHistoryItem[];
// }

const initialState: any = {
    tests: []
};

export const testSlice = createSlice({
  name: 'tests',
  initialState,
  reducers: {
    setTests: (state, action: PayloadAction<any[]>) => {
      state.tests = action.payload;
    }
  }
});

export const { setTests } = testSlice.actions;

export default testSlice.reducer;
